
const initSelectWrappers = () => {
    if(!document.querySelector('.select-input')) {
        return;
    }

    const inputs = document.getElementsByClassName('select-input');
    const selects = document.querySelectorAll('.select-wrapper select');

    for (let i = 0; i < inputs.length; i++) {
        getSelected(i);
        selects[i].addEventListener("change", function() {
            getSelected(i);
        });
    }

    function getSelected(i){
        inputs[i].value = selects[i].options[selects[i].selectedIndex].text;
    }
}

initSelectWrappers();